module.exports = __webpack_public_path__ + "img/triangle-85.23df8a28.gif";